/* eslint quote-props: "off" */
import React, { useEffect, useRef, useState } from 'react';
import { useAuth } from 'react-oidc-context';

import { useQuery } from '@tanstack/react-query';

import { useUXApi } from '../../api';
import CenterLoadingSpinner from '../../components/LoadingSpinner/CenterLoadingSpinner';
import { useAccountContext } from '../../contexts/AccountContext';
import { useUserContext } from '../../contexts/UserContext';

const EAM_URL = import.meta.env.VITE_EAM_URL;

const StrevEmbed: React.FC = () => {
  const accountContext = useAccountContext();
  const userContext = useUserContext();
  const uxApi = useUXApi();

  const tokenQuery = useQuery(['strev-token', userContext.apparentUser.id, accountContext.accountId], async () => {
    const tokenResponse = await uxApi.get_strev_token();

    return tokenResponse.token;
  }, {
    cacheTime: 5*60*1000
  });

  if (tokenQuery.data == null) {
    return <CenterLoadingSpinner />;
  }

  return <iframe src={`${EAM_URL}?token=${tokenQuery.data}`} className='w-screen lg:w-[calc(100vw-64px)] -h-screen-nav' />;
};

export default StrevEmbed;
